// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pratica:hover {\r\n  background-color: #edf5ff;\n}\r\n", ""]);
// Exports
module.exports = exports;
